import { createContext, useContext, useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "@/config/firebase";
import type { CostRangeMarkup } from "@/types";

export type CostMarkupMap = Record<string, CostRangeMarkup[]>;

export const GLOBAL_KEY = "_global";

const CostMarkupContext = createContext<CostMarkupMap>({});

export function CostMarkupProvider({ children }: { children: React.ReactNode }) {
  const [markups, setMarkups] = useState<CostMarkupMap>({});

  useEffect(() => {
    getDoc(doc(db, "admin_config", "category_cost_markups"))
      .then((snap) => {
        if (snap.exists()) {
          const data = snap.data()!;
          const result: CostMarkupMap = {};
          for (const [key, value] of Object.entries(data)) {
            if (key === "_description") continue;
            if (Array.isArray(value)) {
              result[key] = value as CostRangeMarkup[];
            }
          }
          setMarkups(result);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <CostMarkupContext.Provider value={markups}>
      {children}
    </CostMarkupContext.Provider>
  );
}

export function useCostMarkups(): CostMarkupMap {
  return useContext(CostMarkupContext);
}

/**
 * Retorna os cost-range markups pra uma lista de categorias.
 * Retorna o primeiro match de categoria encontrado.
 * Se nenhuma categoria bater, usa _global como fallback.
 */
export function getCostMarkupsForCategories(
  markups: CostMarkupMap,
  categories: string[]
): CostRangeMarkup[] | undefined {
  for (const cat of categories) {
    if (markups[cat]) return markups[cat];
  }
  if (markups[GLOBAL_KEY]) return markups[GLOBAL_KEY];
  return undefined;
}
